// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__pXj7K","disableHover":"IconButton_disableHover__tGspS","icon":"IconButton_icon__ClP7i"};